// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toggle {
    width: 100%;
    /*height: inherit;
    color: inherit;
    text-decoration: inherit;
    text-align: inherit;
    vertical-align: inherit;*/
}


.break {
    white-space: pre-line;
    display: inline; /*verticalAlignment*/
    line-height: normal !important; /*verticalAlignment*/
}

togglebutton {
    color: inherit !important;
    text-align: inherit;
}`, "",{"version":3,"sources":["webpack://./src/app/components/controls/togglebutton/togglebutton.control.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX;;;;6BAIyB;AAC7B;;;AAGA;IACI,qBAAqB;IACrB,eAAe,EAAE,oBAAoB;IACrC,8BAA8B,EAAE,oBAAoB;AACxD;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB","sourcesContent":[".toggle {\n    width: 100%;\n    /*height: inherit;\n    color: inherit;\n    text-decoration: inherit;\n    text-align: inherit;\n    vertical-align: inherit;*/\n}\n\n\n.break {\n    white-space: pre-line;\n    display: inline; /*verticalAlignment*/\n    line-height: normal !important; /*verticalAlignment*/\n}\n\ntogglebutton {\n    color: inherit !important;\n    text-align: inherit;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
